import { render } from "./searchResource.vue?vue&type=template&id=6ab94634&scoped=true"
import script from "./searchResource.vue?vue&type=script&lang=js"
export * from "./searchResource.vue?vue&type=script&lang=js"

import "./searchResource.vue?vue&type=style&index=0&id=6ab94634&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ab94634"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6ab94634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ab94634', script)) {
    api.reload('6ab94634', script)
  }
  
  module.hot.accept("./searchResource.vue?vue&type=template&id=6ab94634&scoped=true", () => {
    api.rerender('6ab94634', render)
  })

}

script.__file = "src/components/searchResource.vue"

export default script